var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF873D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.486 9.918c.966.99 1.56 2.131 1.56 3.394 0 3.509-2.694 5.18-5.94 5.18h-.12c-3.246 0-5.94-1.671-5.94-5.18 0-1.264.594-2.404 1.56-3.394.284-.293.59-.563.916-.809.131-.1.118-.308-.011-.41-.337-.269-.545-.645-.545-1.066 0-.848.826-1.495 1.806-1.495a1.746 1.746 0 01.834.206c.026.014.1-.006.126-.038.074-.111.188-.24.348-.377a1.73 1.73 0 01.966-.42c.363.031.688.185.966.421.16.136.274.265.347.376.027.031.1.051.127.037.054-.031.12-.063.214-.096.198-.075.408-.113.62-.111.98 0 1.806.649 1.806 1.496 0 .421-.209.799-.546 1.067-.129.103-.142.311-.011.41.326.246.632.516.917.81z",
    stroke: "#fff",
    strokeWidth: 1.298
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.314 11.447l-.231.88H9.832l.228-.88h4.254zm-2.21 4.88l-2.167-2.58.003-.792h1.071c.239 0 .439-.044.6-.133a.876.876 0 00.36-.361c.08-.152.122-.326.124-.52-.002-.292-.088-.53-.257-.713-.166-.186-.442-.28-.827-.28H9.832l.26-1.112h.92c.538 0 .987.082 1.346.244.362.161.632.39.812.688.181.298.273.653.275 1.065a2.387 2.387 0 01-.183.957c-.119.273-.306.5-.561.682-.254.182-.585.317-.992.406l-.051.019 1.94 2.374v.057h-1.493zm2.216-6.49l-.237.893h-3.5l.238-.894h3.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.22e150e10b236d929a9d3fbc652bca5e.svg";
export { ForwardRef as ReactComponent };